import { createRouter, createWebHistory } from "vue-router";
import BaseLayout from "@/layouts/BaseLayout.vue";
import BookingModal from "@/modals/BookingModal.vue";
import CreateBookingModal from "@/modals/CreateBookingModal.vue";
import AllowlistEntryInstance from "@/views/AllowlistEntryInstance.vue";
import AllowlistPage from "@/views/AllowlistPage.vue";
import BookingsList from "@/views/BookingsList.vue";
import CreateAllowlistEntry from "@/views/CreateAllowlistEntry.vue";
import EventLogsPage from "@/views/EventLogsPage.vue";
import LogIn from "@/views/LogIn.vue";
import ReportIndex from "@/views/ReportIndex.vue";
import CameraSignView from "@/views/CameraSignView.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      component: BaseLayout,
      children: [
        {
          name: "home",
          path: "",
          redirect: { name: "bookings" },
        },
        {
          name: "bookings",
          component: BookingsList,
          path: "bookings",
          children: [
            {
              name: "bookingInstance",
              path: ":bookingId",
              props: true,
              component: BookingModal,
            },
            {
              name: "bookingCreate",
              path: "create",
              props: true,
              component: CreateBookingModal,
            },
          ],
        },
        {
          name: "allowlist",
          component: AllowlistPage,
          path: "allow-list",
          children: [
            {
              name: "allowlistEntries",
              path: "anpr",
              component: () => import("@/components/AllowlistEntriesTable.vue"),
              children: [
                {
                  name: "createAllowlistEntry",
                  path: "create",
                  component: CreateAllowlistEntry,
                },
                {
                  name: "allowlistEntryInstance",
                  path: ":allowlistEntryId",
                  props: true,
                  component: AllowlistEntryInstance,
                },
              ],
            },
            {
              name: "keypadCodes",
              path: "keypad",
              component: () => import("@/components/KeypadCodesTable.vue"),
              children: [
                {
                  name: "createKeypadCode",
                  path: "create",
                  component: () => import("@/views/CreateKeypadCode.vue"),
                },
                {
                  name: "keypadCodeInstance",
                  path: ":keypadCodeId",
                  props: true,
                  component: () => import("@/views/KeypadCodeInstance.vue"),
                },
              ],
            },
          ],
        },
        {
          // Back-compat: Allow List used to live at /allowlist (with /entries,
          // /keypad-codes tabs). Redirect the whole old subtree.
          path: "allowlist",
          redirect: { name: "allowlistEntries" },
        },
        {
          path: "allowlist/:pathMatch(.*)*",
          redirect: { name: "allowlistEntries" },
        },
        {
          name: "cameraEvents",
          component: EventLogsPage,
          path: "entry-log/anpr",
        },
        {
          name: "entryLogKeypad",
          component: EventLogsPage,
          path: "entry-log/keypad",
        },
        {
          name: "entryLogStorage",
          component: EventLogsPage,
          path: "entry-log/storage",
        },
        {
          path: "entry-log",
          redirect: { name: "cameraEvents" },
        },
        {
          // Back-compat: the log used to live at /camera-events.
          path: "camera-events",
          redirect: { name: "cameraEvents" },
        },
        {
          name: "reports",
          component: ReportIndex,
          path: "reports",
        },
        {
          name: "keycodes",
          component: () => import("@/views/KeycodeList.vue"),
          path: "keycodes",
        },
        {
          name: "pitches",
          component: () => import("@/views/PitchesPage.vue"),
          path: "site-plan",
        },
        {
          // Back-compat: the page used to live at /pitches (and briefly /siteplan).
          path: "pitches",
          redirect: { name: "pitches" },
        },
        {
          path: "siteplan",
          redirect: { name: "pitches" },
        },
        {
          // The compound map. A pitch's popup links to its booking, which
          // opens in the ordinary booking dialog over it.
          name: "storage",
          component: () => import("@/views/StoragePage.vue"),
          path: "storage",
          children: [
            {
              name: "storageBooking",
              path: ":bookingId",
              props: true,
              component: BookingModal,
            },
          ],
        },
        {
          name: "cameraSign",
          component: CameraSignView,
          path: "camera-sign",
        },
        {
          name: "companionContent",
          component: () => import("@/views/CompanionContentPage.vue"),
          path: "companion-content",
        },
      ],
    },
    {
      name: "logIn",
      component: LogIn,
      path: "/login",
    },
  ],
});

export default router;
